<% var component = new Anvil.models.components.Timer(params) %>
<span anvil-component="<%- component.id %>" class="d-none"></span>